import { render, staticRenderFns } from "./UserDetail.vue?vue&type=template&id=a50a8790&scoped=true&"
var script = {}
import style0 from "./UserDetail.vue?vue&type=style&index=0&id=a50a8790&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50a8790",
  null
  
)

export default component.exports